import { render, staticRenderFns } from "./officeConfirmNew.vue?vue&type=template&id=080973c5&"
import script from "./officeConfirmNew.vue?vue&type=script&lang=js&"
export * from "./officeConfirmNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080973c5')) {
      api.createRecord('080973c5', component.options)
    } else {
      api.reload('080973c5', component.options)
    }
    module.hot.accept("./officeConfirmNew.vue?vue&type=template&id=080973c5&", function () {
      api.rerender('080973c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/officeConfirmNew.vue"
export default component.exports